import { Component, input, output } from '@angular/core';
import { TOption } from '../../components/rid-option/rid-option';
import { RidSyllabicKeyboardAssignments } from '../rid-syllabic-keyboard-assignments/rid-syllabic-keyboard-assignments';

@Component({
  selector: 'rid-multisyllabic-keyboard-klankvoeten',
  imports: [RidSyllabicKeyboardAssignments],
  templateUrl: './rid-multisyllabic-keyboard-klankvoeten.html',
})
export class RidMultisyllabicKeyboardKlankvoeten {
  prompts = input.required<{ prompt: TOption; answer: ('>' | '<')[] }[]>();

  finished = output<void>();
}
